<div class="message-container">
  <button (click)="close()" mat-icon-button>
    <mat-icon>close</mat-icon>
  </button>
  <div class="mt-2">
    <p *ngFor="let message of  messages">{{ message }}</p>
  </div>

</div>
